import * as tslib_1 from "tslib";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { OnDestroy, OnInit } from '@angular/core';
import { NbAuthComponent, NbAuthService } from '@nebular/auth';
import { BusinessService } from '../_services/business.service';
import { Location } from '@angular/common';
import { NbMediaBreakpointsService, NbThemeService } from '@nebular/theme';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { darkenHexColor, hexToRgba } from '../@core/utils/color-utils';
var AuthComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AuthComponent, _super);
    function AuthComponent(auth, location, businessService, themeService, breakpointService) {
        var _this = _super.call(this, auth, location) || this;
        _this.auth = auth;
        _this.location = location;
        _this.businessService = businessService;
        _this.themeService = themeService;
        _this.breakpointService = breakpointService;
        _this.showHeader = false;
        _this.destroy$ = new Subject();
        return _this;
    }
    AuthComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.businessService.current().subscribe(function (business) {
            _this.business = business;
            document.documentElement.style.setProperty('--primary-color', _this.business.primary_color || '#5b53f0');
            document.documentElement.style.setProperty('--primary-light-color', hexToRgba(_this.business.primary_color || '#5b53f0', 0.1));
            document.documentElement.style.setProperty('--primary-dark-color', darkenHexColor(_this.business.primary_color || '#5b53f0', 20));
            document.documentElement.style.setProperty('--primary-negative-color', _this.business.primary_negative_color || '#ffffff');
            document.documentElement.style.setProperty('--secondary-color', _this.business.secondary_color || '#009EF3');
            document.documentElement.style.setProperty('--secondary-negative-color', _this.business.secondary_negative_color || '#ffffff');
            document.documentElement.style.setProperty('--navbar-color', _this.business.navbar_color || '#5b53f0');
            document.documentElement.style.setProperty('--navbar-negative-color', _this.business.navbar_negative_color || '#ffffff');
        });
        var xl = this.breakpointService.getBreakpointsMap().xl;
        this.themeService
            .onMediaQueryChange()
            .pipe(map(function (_a) {
            var currentBreakpoint = _a[1];
            return currentBreakpoint.width < xl;
        }), takeUntil(this.destroy$))
            .subscribe(function (isLessThanXl) {
            _this.showHeader = isLessThanXl;
        });
    };
    return AuthComponent;
}(NbAuthComponent));
export { AuthComponent };
